import {
    useMemo,
} from 'react'
import isString from 'lodash/isString'
import useLabel from 'app/hooks/useLabel'

import {
    FormError,
} from 'app/types/common.types'
import useStyles from './FormErrorLabels.styles'

type Props = {
    error: FormError
    id: string
}
const FormErrorLabels = ({
    error, id,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const replaceErrorFields = (template: string, values: string[]) => {
        return values.reduce((acc, value) => {
            return acc.replace(/%s/, value)
        }, template)
    }

    const labels = useMemo(() => {
        return error.fields?.map((field) => {
            const translationKey = `${id}.${field}`
            const translation = l(translationKey)

            // If the translation is the same as the key,
            // it means there is no translation available,
            // possible because it is a message for BE
            // and in this case we want return the original field name
            return translation !== translationKey ? translation : field
        })
    }, [
        error.fields,
        id,
        l,
    ])

    if (!labels || labels.length === 0) {
        return (
            <span className={classes.spanWrapper}>
                {error.message || (isString(error) ? String(error) : null)}
            </span>
        )
    }

    return (
        <>
            {labels.map((label, i) => {
                return (
                    <span
                        key={label || i}
                        className={classes.spanWrapper}
                    >
                        {`${label}: `}
                        {error.message.includes('%') ? replaceErrorFields(error.message, labels) : error.message}
                    </span>
                )
            })}
        </>
    )
}

export default FormErrorLabels
